/* this file is transformed by vux-loader */
/* eslint-disable */
import "E:\\pm-ningde\\ppos-web-propertyManage\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "E:\\pm-ningde\\ppos-web-propertyManage\\node_modules\\core-js\\modules\\es.promise.js";
import "E:\\pm-ningde\\ppos-web-propertyManage\\node_modules\\core-js\\modules\\es.object.assign.js";
import "E:\\pm-ningde\\ppos-web-propertyManage\\node_modules\\core-js\\modules\\es.promise.finally.js";
import Vue from 'vue';
import FastClick from 'fastclick';
import App from './App.vue';
import router from './router';
import './permission'; // 权限控制
import '@/icons';
import store from './store';
import WechatPlugin from "vux/src/plugins/wechat/index.js";
import ToastPlugin from "vux/src/plugins/toast/index.js";
import LoadingPlugin from "vux/src/plugins/loading/index.js"; // svg-icon
/* 快速点击问题处理*/
// if ('addEventListener' in document) {
//   document.addEventListener('DOMContentLoaded', function() {
//     FastClick.attach(document.body)
//   }, false)
// }
// FastClick的ios点击穿透解决方案
FastClick.prototype.focus = function (targetElement) {
  var length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};
FastClick.attach(document.body);
Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);
Vue.use(WechatPlugin);
Vue.config.productionTip = false;
new Vue({
  store: store,
  router: router,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');